import { ToastProgrammatic } from 'buefy'

let params = {
    // position: "is-bottom",
    position: "is-top-right",
    duration: 4000,
    queue: false,
}

const Toast = {
    success: (message) => {
        params.type = "is-success"
        params.message = message
        ToastProgrammatic.open(params)
    },
    warn: (message) => {
        params.type = "is-warning"
        params.message = message
        ToastProgrammatic.open(params)
    },
    error: (message) => {
        params.type = "is-danger"
        params.message = message
        ToastProgrammatic.open(params)
    },
}

export default Toast